// import React, { useEffect, useState } from "react";
// import BlogCard from "./Cards/BlogCard";
// import PropTypes from "prop-types";
// import { makeStyles } from "@material-ui/core/styles";
// import AppBar from "@material-ui/core/AppBar";
// import Tabs from "@material-ui/core/Tabs";
// import Tab from "@material-ui/core/Tab";
// import Typography from "@material-ui/core/Typography";
// import Box from "@material-ui/core/Box";
// import Divider from "@material-ui/core/Divider";
// import Loader from "../utils/loader";
// import { withRouter } from "react-router-dom";
// import { Modal, Button } from "antd";
// import page0 from "./../../src/static/Group 745.png";
// import page1 from "./../../src/static/Group 746.png";
// import {
//   getAllBlogs,
//   getBlogTags,
//   getAllUsersBlogs,
//   searchBlogByName,
//   getBlogById,
//   publishMyBlogs,
//   unpublishMyBlogs,
//   getBlogByTags,
//   ShareableLink,
//   deletePermanentlyBlog

// } from "../services/blogServices";
// import { checkFeatureAccess } from "./featureAccess";
// import { getProfile } from "../services/userService";
// import PostTabs from "./PostTabs";
// import { toast, ToastContainer } from "react-toastify";
// import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
// import _ from "lodash";
// import "./Blog.css";
// import HeadingB from "./Cards/HeadingB";
// import NoBlog from "../static/noBlog.png";
// import swal from "sweetalert";
// import { camelCase, paramCase } from "change-case";
// import InputBoxMui from "./ReusableComponents/InputBoxMui";
// import { addUserLogs } from "../services/userLogServices";
// import { useCheckSubscriptionPlanAccess } from "./SubscriptionAccess";
// import SubscriptionRequired from "./SubscriptionRequired";

// function TabPanel(props) {
//   const { children, value, index, ...other } = props;

//   return (
//     <Typography
//       component="div"
//       role="tabpanel"
//       hidden={value !== index}
//       id={`scrollable-prevent-tabpanel-${index}`}
//       aria-labelledby={`scrollable-prevent-tab-${index}`}
//       {...other}
//     >
//       {value === index && <Box p={3}>{children}</Box>}
//     </Typography>
//   );
// }

// TabPanel.propTypes = {
//   children: PropTypes.node,
//   index: PropTypes.any.isRequired,
//   value: PropTypes.any.isRequired,
// };

// function a11yProps(index) {
//   return {
//     id: `scrollable-prevent-tab-${index}`,
//     "aria-controls": `scrollable-prevent-tabpanel-${index}`,
//   };
// }

// function LinkTab(props) {
//   return (
//     <Tab
//       component="a"
//       onClick={(event) => {
//         event.preventDefault();
//       }}
//       {...props}
//     />
//   );
// }

// const useStyles = makeStyles((theme) => ({
//   root: {
//     flexGrow: 1,
//     backgroundColor: theme.palette.background.paper,
//   },
// }));

// function Blog({ history }) {
//   const classes = useStyles();
//   const [values, setValue] = React.useState(0);
//   const [blogs, setBlogs] = useState([]);
//   const [blogTags, setblogTags] = useState([]);
//   const [filterBlog, setfilterBlog] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [value, setsearchvalue] = useState("");
//   const [tabValue, setSwitchTabValue] = useState("0");
//   const [yourPost, setYourPost] = useState(false);
//   const [page, setPage] = useState(0);
//   const [blogValue, setblogValue] = useState("all");
//   const [LastPage, setLastPage] = useState(0);
//   const [noMyBlogs, setnoMyBlogs] = useState(false);
//   const [noYRBlogs, setnoYRBlogs] = useState(false);
//   const [selectedTag, setSelectedTag] = useState("")
//   const [windowWidth, setWindowWidth] = useState(window.innerWidth);

//   const [isDarkMode, setIsDarkMode] = useState(false);
//   const accessToBlogsScreen = useCheckSubscriptionPlanAccess("Blogs")
//   const [subReqOpen, setSubReqOpen] = useState(false)


// //   useEffect(()=>{
// //     if(!accessToBlogsScreen){
// //      setSubReqOpen(true)
// //     }
// //  },[])

//  useEffect(() => {
//   if (accessToBlogsScreen === false) {
//       setSubReqOpen(true);  
//   }
// }, [accessToBlogsScreen]);

//   useEffect(() => {
//       const updateTheme = () => {
//         const theme = localStorage.getItem('ThemeSwitch');
//         setIsDarkMode(theme === 'true');
//       };
//       updateTheme();
//       window.addEventListener('storage', updateTheme);
//       const originalSetItem = localStorage.setItem;
//       localStorage.setItem = function (key, value) {
//         originalSetItem.apply(this, arguments);
//         if (key === 'ThemeSwitch') {
//           updateTheme(); 
//         }
//       };
//       return () => {
//         window.removeEventListener('storage', updateTheme);
//         localStorage.setItem = originalSetItem; 
//       };
//     }, []);

    
//   const showCard = 5;
//   let pages = 0;

//   const steps = [
//     {
//       selector: ".reactour-3",
//       content: "Click to get sharable link of this blog.",
//       position: "bottom",
//     },
//   ];
 
//   // Update windowWidth on resize
//   useEffect(() => {
//     const handleResize = () => setWindowWidth(window.innerWidth);
 
//     window.addEventListener('resize', handleResize);
//     // if(window.innerWidth <768){
//     //   setSidebarOpen(!isSidebarOpen)
//     // }
 
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);


//   useEffect(() => {
//     // getBlogs();
//     getAllBlog(blogValue);
//   }, [page, blogValue]);

//   // handle publish

//   const handlePublish = async (data) => {
//     swal({
//       title: "Send Blog for Admin Approval",
//       text:
//         "Are you sure ? You want to send the blog for Admin approval in-order to publish this blog",
//       icon: "warning",
//       buttons: true,
//       dangerMode: true,
//     }).then(async (willPublish) => {
//       if (willPublish) {
//         let blog = await getBlogById(data._id);
//         console.log(blog);
//         if (blog.status === 200) {
//           if (blog.data.activeDoc === true) {
//             let responseBlog = await publishMyBlogs(data._id);
//             toast.success("Blog sent for approval!");
//             console.log(responseBlog);
//           }
//           getAllBlog("my");
//         }
//       }
//     });
//   };

//   // handle unpublish

//   const handleUnpublish = async (data) => {
//     swal({
//       title: "Unpublish Blog",
//       text: "Are you sure ? You want to unpublish this blog",
//       icon: "warning",
//       buttons: true,
//       dangerMode: true,
//     }).then(async (willunPublish) => {
//       if (willunPublish) {
//         let blog = await getBlogById(data._id);
//         console.log(data);

//         if (blog.status === 200) {
//           if (blog.data.activeDoc === true) {
//             let unpublishBlog = await unpublishMyBlogs(data._id);
//             toast.success("Blog unpublished!");
//             console.log(unpublishBlog);
//           }
//           getAllBlog("my");
//         } else {
//           toast.error("Sommething went wrong");
//         }
//       }
//     });
//   };

//   useEffect(() => {
//     const handleResize = () => setWindowWidth(window.innerWidth);
 
//     window.addEventListener('resize', handleResize);

 
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   // Get All Users Blogs
//   const getAllBlog = async (value) => {
//     setSelectedTag("Latest Blogs")
//     console.log(showCard, page, value, "in valuee");
//     setLoading(true);
//     const res = await getAllUsersBlogs(showCard, page, value);
//     console.log("res from getAllUsersBlogs", res);

//     if (res.status === 200) {
//       if (res.data.length == 0) {
//         if (value === "my") {
//           // const textWithoutHTML = res.data?.onlyDocumentData?.replace(/<[^>]*>/g, '');
//           // const textWithNewlines = textWithoutHTML?.replace(/<br\s*\/?>/gi, '\n');
//           // const formattedText = {
//           //   blocks: [
//           //     {
//           //       key: "9ukr0",
//           //       text: textWithNewlines,
//           //       type: "unstyled",
//           //       depth: 0,
//           //       inlineStyleRanges: [],
//           //       entityRanges: [],
//           //       data: {}
//           //     }
//           //   ],
//           //   entityMap: {}
//           // };

//           // const jsonText = JSON.stringify(formattedText);
//           // console.log(jsonText,"jsonText");

//           // res.data.onlyDocumentContent = jsonText;
//           setnoMyBlogs(true);
//           setLoading(false);
//         } else if (value === "all") {
//           setnoYRBlogs(true);
//           setLoading(false);
//         }
//       } else {
//         setBlogs(res.data);
//         setfilterBlog(res.data);
//         setLastPage(Math.ceil(res.pages - 1));
//         setLoading(false);
//         setnoMyBlogs(false);
//       }
//     } else {
//       setLoading(false);
//       toast.error(res.message);

//       console.log("Oops something went worng");
//     }
//     getAllTags();
//   };

//   const handleChange = (event, newValue) => {
//     setValue(newValue);
//     console.log(values, "values");
//   };
//   console.log(values, "values2");
//   const openTextEditor = () => {
//     // const access = checkFeatureAccess('blogs','writeBlog')
//     //         if(!access){
//     //             toast.error("You do not have access to write blog")
//     //             return
//     //         }
//     setLoading(true);
//     history.push({
//       pathname: `/grammarcheck`,
//       data: { documentType: "blog" },
//     });
//     setLoading(false);
//   };

//   ///get all my blogs
//   // const getBlogs = async () => {
//   //   setLoading(true);
//   //   let blogs = await getAllBlogs();
//   //   console.log("blogs", blogs);
//   //   if (blogs.status === 200) {
//   //     setBlogs(blogs.data);
//   //     setfilterBlog(blogs.data);
//   //     setYourPost(true);
//   //   } else {
//   //     setLoading(false);
//   //   }
//   //   getAllTags();
//   // };

//   const getAllTags = async () => {
//     let allTags = await getBlogTags();
//     console.log("blogs", allTags);
//     let tags = allTags.data;
//     let freqMap = [];
//     setLoading(true);

//     tags.map((tag) => {
//       tag = tag.toLowerCase();
//       if (!freqMap[tag]) {
//         freqMap[tag] = 0;
//       }
//       freqMap[tag] += 1;
//     });
//     console.log(freqMap);
//     const object = Object.entries(freqMap).map(([key, val]) => ({
//       name: key,
//       index: val,
//     }));
//     console.log(object);
//     const list = object
//       .sort((a, b) => a.index - b.index)
//       .map((exemple, index, array) => exemple.name)
//       .reverse()
//       .slice(0, 7);
//     if (list) {
//       let initial = ["Latest Blogs"];
//       var merge = _.concat(initial, list);
//       setblogTags(merge);
//       // let blogs = await getAllBlogs();
//       // let filterBlog = blogs.data.filter((ok) => {
//       //   for (let i = 0; i < ok.tags.length; i++) {
//       //     if (ok.tags[i] === list[0]) {
//       //       return ok;
//       //     }
//       //   }
//       // });
//       // setfilterBlog(filterBlog);
//     }
//     setLoading(false);
//     console.log(blogTags, "blogTags");
//   };

//   const searchBlog = async (tag, index) => {
//     if (index !== 0) {

//       console.log(index, tag);
//       setSelectedTag(tag)
//       setLoading(true);
//       setfilterBlog([]);
//       let blog = blogs;
//       let alltags = blogTags;
//       // let filterBlog = blog.filter((ok) => {
//       //   for (let i = 0; i < ok.tags.length; i++) {
//       //     if (ok.tags[i] === tag) {
//       //       return ok;
//       //     }
//       //   }
//       // });
//       let filterBlog = await getBlogByTags(tag);
//       setfilterBlog(filterBlog.data);
//       // console.log(filterBlog);
//       setLoading(false);
//     } else {
//       getAllBlog("all");
//     }
//   };

//   const viewBlog = (blog) => {
//     console.log(blogValue);
//     history.push({
//       pathname: `/blogpreview/${blog._id}`,
//       state: { detail: blog, blogType: blogValue, blogTags: blog.tags },
//       data: { documentType: "blog" },
//     });
//   };

//   const filterOnChange = async (e) => {
//     if (e.target.value === "") {
//       setPage(0);
//       setfilterBlog(blogs);
//     }
//     setsearchvalue(e.target.value);
//   };

//   const searchBlogName = async () => {
//     setLoading(true);
//     console.log(value);
//     if (value === "") {
//       setLoading(false);
//       toast.error("Please enter value to search!");
//     } else {
//       let result = await searchBlogByName(value, blogValue);
//       console.log(result);
//       setLoading(false);
//       setfilterBlog(result);
//     }
//   };
//   console.log(blogValue, "blogValue");
//   console.log(selectedTag, "selectedTag");
//   const switchTab = (value) => {
//     console.log(value, "inside value");
//     setSwitchTabValue(value);
//     if (value == "0") {
//       setblogValue("all");
//       setPage(0);
//       setYourPost(false);
//     } else if (value == "1") {
//       setblogValue("my");
//       setPage(0);
//       setYourPost(true);
//       setValue(0);
//     }
//   };
//   console.log(tabValue, "tabValue");
//   const [isShareModal, setIsShareModal] = useState(false)
//   const [shareLink, setShareLink] = useState("")

//   const handleShareModal = () => {
//     setIsShareModal(false)
//   }

//   const handleCopy = () => {
//     console.log("shareLink", shareLink)
//     let link = shareLink
//     if (link == "") {
//       toast.warn(`You don't have text, to copy`);
//       return;
//     }
//     navigator.clipboard.writeText(link).then(
//       function () {
//         console.log("Async: Copying to clipboard was successful!");
//         if (link) toast.info("Link is Copied!");
//       },
//       function (err) {
//         console.error("Async: Could not copy text: ", err);
//       }
//     );
//   }

//   const shareableLink = async (data) => {
//     console.log("shareableLink", data)
//     let link = await ShareableLink(data._id, paramCase(data.documentName));

//     const el = document.createElement("textarea");
//     el.value = link;
//     document.body.appendChild(el);
//     el.select();
//     document.execCommand("copy");
//     document.body.removeChild(el);
//     console.log(el.value);
//     setShareLink(el.value)
//     setIsShareModal(true)

//     // window.open(link, "_blank");
//   };

//   const permanentDeleteBlog = async (blog) => {
//     swal({
//       title: "Permanent Deletion",
//       text: "Do you want to permanently delete this blog ?",
//       icon: "warning",
//       buttons: true,
//       dangerMode: true,
//     }).then(async (permanentDelete) => {
//       if (permanentDelete) {
//         setLoading(true);
//         let data = {
//           _id: blog._id,
//         };
//         let res = await deletePermanentlyBlog(data);
//         if (res.status !== 200) {
//           setLoading(false);
//           toast.error("Blog Deletion Failed !");
//         }
//         else {
//           toast.success("Blog deleted permanently!");
//           const data = {
//             userId: sessionStorage.getItem("userId"),
//             organizationId: sessionStorage.getItem("organizationId"),
//             actionType: "deleteBlog",
//           };
    
//           const addLogs = await addUserLogs(data);
//           if (addLogs.status !== 200) {
//             toast.error(addLogs.message);
//           }
//           setLoading(false)
//           getAllBlog("my");
//         }

//       } else {
//         swal("Your Blog is safe!");
//       }
//     });
//   };

//   console.log(blogTags.length,"blogTags");
//   return (
//     <div style={{marginLeft:windowWidth <= 768 ? "" : "-30px",width:"100%"}} className="ml-2">
//       <ToastContainer />
//       <SubscriptionRequired open={subReqOpen} setOpen={setSubReqOpen}/>
//       <Loader loading={loading} />
//       <div className="card-bg" style={{width:"99%" ,boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px", borderRadius: "15px", padding: "5px", marginBottom : "14px" }}>
//         <div
//           style={{
//             width:"98%",
//             borderRadius: "7px",
//             borderBottom: noMyBlogs || tabValue == "1" ? "none" : "3px solid gray"
//           }}>
//           <PostTabs handleChangeTab={switchTab} openEditor={openTextEditor} filterOnChange={filterOnChange} searchValue={value} searchBlogName={searchBlogName} />
//         </div>
//         {tabValue == "0" && (
//           <div
//             style={{
//               // marginTop: "10px",
//               width: windowWidth < 960 ? "100%" : '950px',
//             }}
//           >
//             {/* <AppBar position="static"> */}
//             <Box 
//             className="card-bg"
//             sx={{
//               maxWidth: { xs: 320, sm: 480, md: 1070 },
//               width: '100%',
//               display: 'flex', // Flexbox to position the first tab and the rest of the tabs side by side
//               alignItems: 'center',
//             }}>
//                 {/* First Tab (Fixed) */}
//                 <Tab
//                 label={blogTags[0]}  // First tab remains constant
//                 key={0}
//                 {...a11yProps(0)}
//                 onClick={() => searchBlog(blogTags[0], 0)}
//                 sx={{
//                   height: 5, // Minimum height for responsiveness
//                   flexShrink: 0, // Prevent shrinking when resizing
//                 }}
//                 disabled={false}
//                 style={{
//                   backgroundColor: isDarkMode ? (selectedTag == blogTags[0] ? "transparent" : "#858585")  : (selectedTag == blogTags[0] ? "rgb(122 197 241)" : "white"),
//                   border: "1px solid #007BFF",
//                   color: "#007BFF",
//                   margin: "7px",
//                   outline: "none",
//                   borderRadius: "7px",
//                   padding: "0px",
//                 }}
//               />

//               {/* Scrollable Tabs (Remaining Items) */}


//               <Tabs
//                 value={values}
//                 onChange={handleChange}
//                 indicatorColor="white"
//                 textColor="primary"
//                 aria-label="scrollable force tabs example"
//                 scrollButton
//                 variant="scrollable"
//                 style={{width: '100%'}}
//               >

//                 {blogTags.slice(1).map((tag, index) => (
//                   <Tab
//                     label={tag}
//                     key={index+1}
//                     {...a11yProps(index)}
//                     // disabled={tabDisable}
//                     onClick={() => searchBlog(tag, index+1)}
//                     sx={{
//                       height: 5, // Minimum height for responsiveness
//                     }}
//                     style={{
//                       backgroundColor: isDarkMode ? '#858585' : (selectedTag === tag ? "#AFDBF5" : "white"),
//                       border: "1px solid dodgerblue",
//                       color: selectedTag === tag ? "white" : "dodgerblue",
//                       margin: "7px",
//                       outline: "none",
//                       borderRadius: "7px",
//                       padding: "0px"
//                     }}
//                   />
//                 ))}
//               </Tabs>
//             </Box>
//             {/* </AppBar> */}
//           </div>
//         )
//       }
//       </div>
//       {/* {blogs.length > 0 ? ( */}


// <div style={{width:"100%"}}>
// {tabValue === "0" && noYRBlogs ? (
//         <div className="text-center mt-4">
//           <img
//             className=" mt-5"
//             style={{ height: "150px" }}
//             src={NoBlog}
//             alt="404"
//           ></img>
//           <HeadingB className="alertHead" text="No Blog Published Yet..!" />
//         </div>
//       ) : tabValue == "1" && noMyBlogs ? (
//         <div className="text-center mt-4">
//           <img
//             className=" mt-5"
//             style={{ height: "150px" }}
//             src={NoBlog}
//             alt="404"
//           ></img>
//           <HeadingB className="alertHead" text="No Blogs Found..!" />
//         </div>
//       ) : (
//         <>
//           <hr
//             style={{ marginLeft: "2%", marginRight: "6%", marginTop: "-1%" }}
//           />
//           {filterBlog?.map((blog, index) => (
//             console.log(blog, "blog"),
//             <BlogCard
//               key={index}
//               data={blog}
//               showBlog={() => viewBlog(blog)}
//               mypost={yourPost}
//               blogunpub={() => handleUnpublish(blog)}
//               blogPub={() => handlePublish(blog)}
//               shareableLink={shareableLink}
//               search={searchBlog}
//               permanentDelete={() => permanentDeleteBlog(blog)}
//             />
//           ))}
//           <hr />

//           <div className="row">
//             {page > 0 && (
//               <div className="col-md-6" style={{ padding: "2%" }}>
//                 <div
//                   className="row point"
//                   style={{ padding: "2%" }}
//                   onClick={() => setPage(page - 1)}
//                 >
//                   <img src={page0} style={{ height: "50px", width: "50px" }} />{" "}
//                   <h6 style={{ paddingTop: "17px" }}>Latest Posts</h6>
//                 </div>
//               </div>
//             )}
//             {page >= 0 && page < LastPage && (
//               <div className="col-md-6 ml-auto" style={{ padding: "2%" }}>
//                 <div
//                   className="point"
//                   style={{ padding: "2%", float: "right" }}
//                   onClick={() => setPage(page + 1)}
//                 >
//                   <span style={{ paddingTop: "17px" }}>Older Posts</span>{" "}
//                   <img
//                     src={page1}
//                     alt="older post"
//                     style={{ height: "50px", width: "50px" }}
//                   />
//                 </div>
//               </div>
//             )}
//           </div>
//         </>
//       )}
// </div>

//       <Modal
//         title="Share link"
//         // style={{ width: "65%" }}
//         width={"55%"}
//         open={isShareModal}
//         // onOk={handleShareModal}
//         onCancel={handleShareModal}
//         footer={null}
//       // footer={[
//       //   <div className="d-flex justify-content-end gap-1">
//       //     <Button className="btn btn-secondary btn-sm" type="secondary"
//       //       onClick={handleShareModal}
//       //     >
//       //       Cancel
//       //     </Button>,
//       //   </div>
//       // ]}
//       >

//         <div className="row"
//         >
//           <div className="col-md-10"
//           >
//             <InputBoxMui
//               fullWidth
//               value={shareLink}
//               disabled={true}
//             />
//           </div>
//           <div className="col-md-2">
//             <Button
//               className="btn btn-secondary btn-sm"
//               style={{
//                 // border: "none",
//                 // background: "transparent",
//                 // minWidth: '20px',
//                 // padding: '4px',
//                 // color: 'black'
//               }}
//               onClick={handleCopy}
//             >
//               Copy
//             </Button>
//           </div>
//         </div>
//       </Modal>

//     </div>
//   );
// }
// export default withRouter(Blog);





// new code for usIng AI only ui

// import React, { useState } from 'react';
// import {
//   AppBar,
//   Toolbar,
//   Typography,
//   Button,
//   Paper,
//   TextField,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Slider,
//   Box,
//   Chip,
//   IconButton,
//   Card,
//   CardContent,
//   CardMedia,
//   Tabs,
//   Tab,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   RadioGroup,
//   FormControlLabel,
//   Radio,
//   Divider,
// } from '@mui/material';
// import Grid from '@mui/material/Unstable_Grid2';
// import { LineChart } from '@mui/x-charts/LineChart';
// import {
//   Add as AddIcon,
//   History as HistoryIcon,
//   Analytics as AnalyticsIcon,
//   Menu as MenuIcon,
//   AutoAwesome as AutoAwesomeIcon,
//   Edit as EditIcon,
//   ExpandMore as ExpandMoreIcon,
//   Search as SearchIcon,
//   Visibility as VisibilityIcon,
//   CheckCircle as CheckCircleIcon,
//   ThumbUp as ThumbUpIcon,
//   Comment as CommentIcon,
//   Computer as ComputerIcon,
//   Smartphone as SmartphoneIcon,
// } from '@mui/icons-material';

// const AIBlogWriter = () => {
//   const [tabValue, setTabValue] = useState(0);
//   const [previewMode, setPreviewMode] = useState('desktop');

//   const blogContent = `AI is the driving solutions that enhance ideas, and automatic whitepapers engaging and digital agents to automatically add toploader conteld.

// The ninning AI flee programs that improve the madenisting of content and services to fill now articut web aboos but contributes to an-earing process.

// AI will score digitally-fulades that fanliae ies to scale the automation process, zs creating more fusely and mulaicd altractors, as-iuse digital isee.

// As industry automation loadshis, we deepen from leeading a-tole projects, leveraging constantly across the leevenging sepvert all-ising automations, and suteulating mobile-spert to increase ideas; as wert as providing mobile content information and websites.

// • How AI improves the content optimization improvements and more developing vis-ble bhing leanming languages.

// • AI Promotes elt-cliert inlution, improving faster, instivating faster`;

//   return (
//     <Box sx={{ flexGrow: 1, bgcolor: '#f5f7fa', minHeight: '100vh' }}>
//       {/* Header */}
//       <AppBar position="static" sx={{ bgcolor: 'white', color: 'black', boxShadow: 1 }}>
//         <Toolbar>
//           <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontWeight: 600 }}>
//             AI Blog Writer
//           </Typography>
//           <Button startIcon={<AddIcon />} variant="contained" sx={{ mr: 2 }}>
//             New Post
//           </Button>
//           <Button startIcon={<HistoryIcon />} variant="outlined" sx={{ mr: 2 }}>
//             History
//           </Button>
//           <Button startIcon={<AnalyticsIcon />} variant="outlined" sx={{ mr: 2 }}>
//             Analytics
//           </Button>
//           <Button startIcon={<MenuIcon />} variant="outlined">
//             Main Blogs
//           </Button>
//         </Toolbar>
//       </AppBar>

//       {/* Main Content */}
//       <Box sx={{ p: 3 }}>
//         <Grid container spacing={3}>
//           {/* Left Sidebar */}
//           <Grid xs={12} md={3}>
//             <Paper sx={{ p: 2, mb: 2 }}>
//               <Typography variant="subtitle1" fontWeight={600} gutterBottom>
//                 Content Source
//               </Typography>
//               <RadioGroup defaultValue="ai">
//                 <FormControlLabel
//                   value="ai"
//                   control={<Radio />}
//                   label={
//                     <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                       <AutoAwesomeIcon sx={{ mr: 1, fontSize: 20, color: 'primary.main' }} />
//                       AI Generate
//                     </Box>
//                   }
//                 />
//                 <FormControlLabel
//                   value="google"
//                   control={<Radio />}
//                   label={
//                     <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                       <SearchIcon sx={{ mr: 1, fontSize: 20 }} />
//                       Google Search
//                     </Box>
//                   }
//                 />
//               </RadioGroup>

//               <Divider sx={{ my: 2 }} />

//               <FormControl fullWidth sx={{ mb: 2 }}>
//                 <InputLabel>Language</InputLabel>
//                 <Select value="english" label="Language">
//                   <MenuItem value="english">English</MenuItem>
//                 </Select>
//               </FormControl>

//               <FormControl fullWidth sx={{ mb: 2 }}>
//                 <InputLabel>Tone</InputLabel>
//                 <Select value="professional" label="Tone">
//                   <MenuItem value="professional">Professional</MenuItem>
//                 </Select>
//               </FormControl>

//               <Typography variant="body2" gutterBottom>
//                 Length:
//               </Typography>
//               <Slider defaultValue={50} />
//             </Paper>

//             <Paper sx={{ p: 2, mb: 2 }}>
//               <Typography variant="subtitle1" fontWeight={600} gutterBottom>
//                 SEO Optimizer
//               </Typography>
//               <Box
//                 sx={{
//                   bgcolor: '#4caf50',
//                   color: 'white',
//                   p: 1,
//                   borderRadius: 1,
//                   textAlign: 'center',
//                   mb: 2,
//                 }}
//               >
//                 Title Score: 85
//               </Box>
//               <Button fullWidth variant="outlined" sx={{ mb: 1 }}>
//                 Meta Description
//               </Button>
//               <Button fullWidth variant="outlined">
//                 Keyword Suggestions
//               </Button>
//             </Paper>

//             <Paper sx={{ p: 2, mb: 2 }}>
//               <Typography variant="subtitle1" fontWeight={600} gutterBottom>
//                 AI Tags Editor
//               </Typography>
//               <Button fullWidth variant="contained" sx={{ mb: 2 }}>
//                 Generate Tags
//               </Button>
//               <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//                 <Chip label="AI Writing" />
//                 <Chip label="Content Creation" />
//                 <Chip label="Digital Marketing" />
//               </Box>
//             </Paper>

//             <Paper sx={{ p: 2 }}>
//               <Typography variant="subtitle1" fontWeight={600} gutterBottom>
//                 Image Generator
//               </Typography>
//               <Typography variant="body2" gutterBottom>
//                 Publish As:
//               </Typography>
//               <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
//                 <Chip label="Draft" color="primary" size="small" />
//                 <IconButton size="small">
//                   <EditIcon fontSize="small" />
//                 </IconButton>
//               </Box>
//               <RadioGroup defaultValue="now">
//                 <FormControlLabel value="now" control={<Radio />} label="Publish Now" />
//                 <FormControlLabel value="schedule" control={<Radio />} label="Schedule" />
//                 <FormControlLabel value="auto" control={<Radio />} label="Auto Publish" />
//               </RadioGroup>
//               <CardMedia
//                 component="img"
//                 image="https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=400&h=250&fit=crop"
//                 alt="City skyline"
//                 sx={{ borderRadius: 1, mt: 2 }}
//               />
//             </Paper>
//           </Grid>

//           {/* Center Content */}
//           <Grid xs={12} md={6}>
//             <Paper sx={{ p: 3, mb: 2 }}>
//               <TextField
//                 fullWidth
//                 label="Blog Title"
//                 defaultValue="The Future of AI in Content Writing"
//                 sx={{ mb: 2 }}
//               />
//               <TextField
//                 fullWidth
//                 label="Slug"
//                 defaultValue="/future-of-ai-in-content-writing"
//                 sx={{ mb: 3 }}
//               />

//               <Box sx={{ display: 'flex', gap: 1, mb: 3, flexWrap: 'wrap' }}>
//                 <Button variant="outlined" startIcon={<AutoAwesomeIcon />}>
//                   Improve
//                 </Button>
//                 <Button variant="outlined" startIcon={<EditIcon />}>
//                   Rewrite
//                 </Button>
//                 <Button variant="outlined" startIcon={<ExpandMoreIcon />}>
//                   Expand
//                 </Button>
//                 <Button variant="outlined">SEO Optimize</Button>
//                 <Button variant="outlined">Humanize</Button>
//               </Box>

//               <TextField
//                 fullWidth
//                 multiline
//                 rows={12}
//                 value={blogContent}
//                 variant="outlined"
//               />

//               <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
//                 <Button variant="contained" size="large">
//                   Save Draft
//                 </Button>
//                 <Button variant="contained" color="success" size="large">
//                   Publish
//                 </Button>
//                 <Button variant="outlined" startIcon={<VisibilityIcon />} size="large">
//                   Preview
//                 </Button>
//               </Box>
//             </Paper>

//             {/* Blog History Tabs */}
//             <Paper>
//               <Tabs value={tabValue} onChange={(e, v) => setTabValue(v)}>
//                 <Tab label="Blog History" />
//                 <Tab label="Drafts" />
//                 <Tab label="Analytics" />
//               </Tabs>
//               <Box sx={{ p: 2 }}>
//                 <List>
//                   <ListItem>
//                     <ListItemIcon>
//                       <CheckCircleIcon color="primary" />
//                     </ListItemIcon>
//                     <ListItemText
//                       primary="AI in Marketing"
//                       secondary="WordPress • Jan 15, 2022"
//                     />
//                   </ListItem>
//                   <ListItem>
//                     <ListItemIcon>
//                       <CheckCircleIcon color="primary" />
//                     </ListItemIcon>
//                     <ListItemText
//                       primary="SEO Best Practices"
//                       secondary="Medium • Dec 10, 2021"
//                     />
//                   </ListItem>
//                   <ListItem>
//                     <ListItemIcon>
//                       <CheckCircleIcon color="primary" />
//                     </ListItemIcon>
//                     <ListItemText
//                       primary="Social Media Trends"
//                       secondary="Custom API • Nov 20, 2021"
//                     />
//                   </ListItem>
//                 </List>
//               </Box>
//             </Paper>
//           </Grid>

//           {/* Right Sidebar - Preview */}
//           <Grid xs={12} md={3}>
//             <Paper sx={{ p: 2 }}>
//               <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
//                 <Button
//                   variant={previewMode === 'desktop' ? 'contained' : 'outlined'}
//                   startIcon={<ComputerIcon />}
//                   onClick={() => setPreviewMode('desktop')}
//                   size="small"
//                   fullWidth
//                 >
//                   Desktop
//                 </Button>
//                 <Button
//                   variant={previewMode === 'mobile' ? 'contained' : 'outlined'}
//                   startIcon={<SmartphoneIcon />}
//                   onClick={() => setPreviewMode('mobile')}
//                   size="small"
//                   fullWidth
//                 >
//                   Mobile
//                 </Button>
//               </Box>

//               <Card>
//                 <CardContent>
//                   <Typography variant="h6" gutterBottom fontWeight={600}>
//                     The Future of AI in Content Writing
//                   </Typography>
//                   <CardMedia
//                     component="img"
//                     image="https://images.unsplash.com/photo-1677442136019-21780ecad995?w=400&h=250&fit=crop"
//                     alt="AI Robot"
//                     sx={{ borderRadius: 1, mb: 2 }}
//                   />
//                   <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
//                     In the evolution of AI automation, creating ageneres, many friendies is designed to the artiat content.
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
//                     AI altitude is apensias in apriais, coatient are pripring intellipages, hat tectume tibiay meterits to digitaal agenta projects, increelaating prorpast colest.
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     Fastersing, the quale of AI: thereaising leads, hadmalgies, automate fundtiloms.
//                   </Typography>
//                 </CardContent>
//               </Card>

//               <Box sx={{ mt: 3, p: 2, bgcolor: 'white', borderRadius: 1 }}>
//                 <Box sx={{ display: 'flex', justifyContent: 'space-around', mb: 2 }}>
//                   <Box sx={{ textAlign: 'center' }}>
//                     <Typography variant="h6" color="primary">
//                       5.2K
//                     </Typography>
//                     <Typography variant="caption" color="text.secondary">
//                       Views
//                     </Typography>
//                   </Box>
//                   <Box sx={{ textAlign: 'center' }}>
//                     <Typography variant="h6" color="error">
//                       820
//                     </Typography>
//                     <Typography variant="caption" color="text.secondary">
//                       Likes
//                     </Typography>
//                   </Box>
//                   <Box sx={{ textAlign: 'center' }}>
//                     <Typography variant="h6" color="info.main">
//                       168
//                     </Typography>
//                     <Typography variant="caption" color="text.secondary">
//                       Comments
//                     </Typography>
//                   </Box>
//                 </Box>

//                 <LineChart
//                   xAxis={[{ data: [1, 2, 3, 4, 5, 6, 7, 8] }]}
//                   series={[
//                     {
//                       data: [3000, 3500, 3200, 4000, 4200, 3800, 4500, 5200],
//                       area: true,
//                       color: '#1976d2',
//                     },
//                   ]}
//                   height={200}
//                   margin={{ top: 10, right: 10, bottom: 30, left: 40 }}
//                 />
//               </Box>
//             </Paper>
//           </Grid>
//         </Grid>
//       </Box>
//     </Box>
//   );
// };

// export default AIBlogWriter;


//new code for using AI with functionality code

import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Paper,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Slider,
  Box,
  Chip,
  IconButton,
  Card,
  CardContent,
  CardMedia,
  Tabs,
  Tab,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  RadioGroup,
  FormControlLabel,
  Radio,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  Alert,
} from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { LineChart } from '@mui/x-charts/LineChart';
import {
  Add as AddIcon,
  History as HistoryIcon,
  Analytics as AnalyticsIcon,
  Menu as MenuIcon,
  AutoAwesome as AutoAwesomeIcon,
  Edit as EditIcon,
  ExpandMore as ExpandMoreIcon,
  Search as SearchIcon,
  Visibility as VisibilityIcon,
  CheckCircle as CheckCircleIcon,
  Delete as DeleteIcon,
  Computer as ComputerIcon,
  Smartphone as SmartphoneIcon,
} from '@mui/icons-material';

const AIBlogWriter = () => {
  const [tabValue, setTabValue] = useState(0);
  const [previewMode, setPreviewMode] = useState('desktop');
  const [contentSource, setContentSource] = useState('ai');
  const [language, setLanguage] = useState('english');
  const [tone, setTone] = useState('professional');
  const [length, setLength] = useState(50);
  const [title, setTitle] = useState('The Future of AI in Content Writing');
  const [slug, setSlug] = useState('/future-of-ai-in-content-writing');
  const [blogContent, setBlogContent] = useState('');
  const [tags, setTags] = useState(['AI Writing', 'Content Creation', 'Digital Marketing']);
  const [publishStatus, setPublishStatus] = useState('draft');
  const [publishTiming, setPublishTiming] = useState('now');
  const [seoScore, setSeoScore] = useState(85);
  const [metaDescription, setMetaDescription] = useState('');
  const [keywords, setKeywords] = useState(['AI', 'content', 'writing', 'automation']);
  const [blogHistory, setBlogHistory] = useState([
    { id: 1, title: 'AI in Marketing', platform: 'WordPress', date: 'Jan 15, 2022', status: 'published', views: 5200, likes: 820, comments: 168 },
    { id: 2, title: 'SEO Best Practices', platform: 'Medium', date: 'Dec 10, 2021', status: 'published', views: 3800, likes: 650, comments: 92 },
    { id: 3, title: 'Social Media Trends', platform: 'Custom API', date: 'Nov 20, 2021', status: 'published', views: 4100, likes: 720, comments: 134 },
  ]);
  const [drafts, setDrafts] = useState([
    { id: 1, title: 'Content Marketing Guide', date: 'Jan 18, 2022' },
    { id: 2, title: 'Email Automation Tips', date: 'Jan 16, 2022' },
  ]);
  const [analytics, setAnalytics] = useState({
    views: [3000, 3500, 3200, 4000, 4200, 3800, 4500, 5200],
    labels: ['Week 1', 'Week 2', 'Week 3', 'Week 4', 'Week 5', 'Week 6', 'Week 7', 'Week 8'],
  });
  const [openDialog, setOpenDialog] = useState('');
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [newTag, setNewTag] = useState('');

  useEffect(() => {
    if (contentSource === 'ai') {
      generateAIContent();
    }
  }, []);

  const generateAIContent = () => {
    const aiContent = `Artificial Intelligence is revolutionizing the way we create and consume content. From automated writing tools to intelligent content optimization, AI is transforming the digital landscape.

In today's fast-paced digital world, content creators are leveraging AI to enhance their productivity and creativity. AI-powered writing assistants can generate high-quality content, suggest improvements, and optimize for search engines.

The integration of AI in content creation offers numerous benefits:

• Faster content production with maintained quality standards
• Enhanced SEO optimization through intelligent keyword analysis
• Personalized content recommendations based on audience behavior
• Automated editing and proofreading capabilities
• Data-driven insights for content strategy

As we move forward, AI will continue to play a crucial role in shaping the future of content creation. It's not about replacing human creativity, but augmenting it with intelligent tools that help us work smarter and more efficiently.

The key to success lies in finding the right balance between AI automation and human creativity, ensuring that content remains authentic, engaging, and valuable to readers.`;
    
    setBlogContent(aiContent);
    showSnackbar('AI content generated successfully!', 'success');
  };

  const improveContent = () => {
    const improved = blogContent + '\n\nEnhanced with AI: This content has been optimized for better readability and engagement.';
    setBlogContent(improved);
    showSnackbar('Content improved!', 'success');
  };

  const rewriteContent = () => {
    const rewritten = `Reimagined Content:\n\n${blogContent.split('\n').reverse().join('\n')}`;
    setBlogContent(rewritten);
    showSnackbar('Content rewritten!', 'success');
  };

  const expandContent = () => {
    const expanded = blogContent + '\n\nAdditional insights: The evolution of AI technology continues to present new opportunities for content creators worldwide. By embracing these tools, we can unlock unprecedented levels of creativity and efficiency.';
    setBlogContent(expanded);
    showSnackbar('Content expanded!', 'success');
  };

  const seoOptimize = () => {
    const newScore = Math.min(100, seoScore + Math.floor(Math.random() * 10) + 5);
    setSeoScore(newScore);
    showSnackbar(`SEO score improved to ${newScore}!`, 'success');
  };

  const humanizeContent = () => {
    setBlogContent(blogContent.replace(/AI/g, 'artificial intelligence'));
    showSnackbar('Content humanized!', 'success');
  };

  const generateTags = () => {
    const newTags = ['Technology', 'Innovation', 'Automation', 'Future Trends', 'Digital Transformation'];
    setTags([...tags, ...newTags.filter(tag => !tags.includes(tag))]);
    showSnackbar('Tags generated!', 'success');
  };

  const addTag = () => {
    if (newTag && !tags.includes(newTag)) {
      setTags([...tags, newTag]);
      setNewTag('');
      showSnackbar('Tag added!', 'success');
    }
  };

  const removeTag = (tagToRemove) => {
    setTags(tags.filter(tag => tag !== tagToRemove));
  };

  const saveDraft = () => {
    const newDraft = {
      id: drafts.length + 1,
      title,
      date: new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }),
      content: blogContent,
    };
    setDrafts([newDraft, ...drafts]);
    showSnackbar('Draft saved successfully!', 'success');
  };

  const publishPost = () => {
    const newPost = {
      id: blogHistory.length + 1,
      title,
      platform: 'WordPress',
      date: new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }),
      status: 'published',
      views: Math.floor(Math.random() * 3000) + 1000,
      likes: Math.floor(Math.random() * 500) + 200,
      comments: Math.floor(Math.random() * 100) + 50,
    };
    setBlogHistory([newPost, ...blogHistory]);
    showSnackbar('Post published successfully!', 'success');
  };

  const createNewPost = () => {
    setTitle('');
    setSlug('');
    setBlogContent('');
    setTags([]);
    setSeoScore(0);
    showSnackbar('New post created!', 'info');
  };

  const updateSlug = (newTitle) => {
    setTitle(newTitle);
    const slugified = '/' + newTitle.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    setSlug(slugified);
  };

  const showSnackbar = (message, severity = 'success') => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const deleteDraft = (id) => {
    setDrafts(drafts.filter(draft => draft.id !== id));
    showSnackbar('Draft deleted!', 'info');
  };

  const loadDraft = (draft) => {
    setTitle(draft.title);
    setBlogContent(draft.content || '');
    updateSlug(draft.title);
    showSnackbar('Draft loaded!', 'success');
  };

  return (
    <Box sx={{ flexGrow: 1, bgcolor: '#f5f7fa', minHeight: '100vh' }}>
      {/* Header */}
      <AppBar position="static" sx={{ bgcolor: 'white', color: 'black', boxShadow: 1 }}>
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontWeight: 600 }}>
            AI Blog Writer
          </Typography>
          <Button startIcon={<AddIcon />} variant="contained" sx={{ mr: 2 }} onClick={createNewPost}>
            New Post
          </Button>
          <Button startIcon={<HistoryIcon />} variant="outlined" sx={{ mr: 2 }} onClick={() => setTabValue(0)}>
            History
          </Button>
          <Button startIcon={<AnalyticsIcon />} variant="outlined" sx={{ mr: 2 }} onClick={() => setTabValue(2)}>
            Analytics
          </Button>
          <Button startIcon={<MenuIcon />} variant="outlined">
            Main Blogs
          </Button>
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Box sx={{ p: 3 }}>
        <Grid container spacing={3}>
          {/* Left Sidebar */}
          <Grid xs={12} md={3}>
            <Paper sx={{ p: 2, mb: 2 }}>
              <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                Content Source
              </Typography>
              <RadioGroup value={contentSource} onChange={(e) => setContentSource(e.target.value)}>
                <FormControlLabel
                  value="ai"
                  control={<Radio />}
                  label={
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <AutoAwesomeIcon sx={{ mr: 1, fontSize: 20, color: 'primary.main' }} />
                      AI Generate
                    </Box>
                  }
                />
                <FormControlLabel
                  value="google"
                  control={<Radio />}
                  label={
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <SearchIcon sx={{ mr: 1, fontSize: 20 }} />
                      Google Search
                    </Box>
                  }
                />
              </RadioGroup>

              {contentSource === 'ai' && (
                <Button fullWidth variant="contained" sx={{ mt: 2 }} onClick={generateAIContent}>
                  Generate Content
                </Button>
              )}

              <Divider sx={{ my: 2 }} />

              <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel>Language</InputLabel>
                <Select value={language} label="Language" onChange={(e) => setLanguage(e.target.value)}>
                  <MenuItem value="english">English</MenuItem>
                  <MenuItem value="spanish">Spanish</MenuItem>
                  <MenuItem value="french">French</MenuItem>
                  <MenuItem value="german">German</MenuItem>
                </Select>
              </FormControl>

              <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel>Tone</InputLabel>
                <Select value={tone} label="Tone" onChange={(e) => setTone(e.target.value)}>
                  <MenuItem value="professional">Professional</MenuItem>
                  <MenuItem value="casual">Casual</MenuItem>
                  <MenuItem value="formal">Formal</MenuItem>
                  <MenuItem value="friendly">Friendly</MenuItem>
                </Select>
              </FormControl>

              <Typography variant="body2" gutterBottom>
                Length: {length}%
              </Typography>
              <Slider value={length} onChange={(e, val) => setLength(val)} />
            </Paper>

            <Paper sx={{ p: 2, mb: 2 }}>
              <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                SEO Optimizer
              </Typography>
              <Box
                sx={{
                  bgcolor: seoScore > 70 ? '#4caf50' : seoScore > 40 ? '#ff9800' : '#f44336',
                  color: 'white',
                  p: 1,
                  borderRadius: 1,
                  textAlign: 'center',
                  mb: 2,
                }}
              >
                Title Score: {seoScore}
              </Box>
              <Button fullWidth variant="outlined" sx={{ mb: 1 }} onClick={() => setOpenDialog('meta')}>
                Meta Description
              </Button>
              <Button fullWidth variant="outlined" onClick={() => setOpenDialog('keywords')}>
                Keyword Suggestions
              </Button>
            </Paper>

            <Paper sx={{ p: 2, mb: 2 }}>
              <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                AI Tags Editor
              </Typography>
              <Button fullWidth variant="contained" sx={{ mb: 2 }} onClick={generateTags}>
                Generate Tags
              </Button>
              <Box sx={{ mb: 2 }}>
                <TextField
                  size="small"
                  fullWidth
                  placeholder="Add custom tag"
                  value={newTag}
                  onChange={(e) => setNewTag(e.target.value)}
                  onKeyPress={(e) => e.key === 'Enter' && addTag()}
                />
              </Box>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {tags.map((tag, index) => (
                  <Chip
                    key={index}
                    label={tag}
                    onDelete={() => removeTag(tag)}
                    color="primary"
                    variant="outlined"
                  />
                ))}
              </Box>
            </Paper>

            <Paper sx={{ p: 2 }}>
              <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                Publishing Options
              </Typography>
              <Typography variant="body2" gutterBottom>
                Publish As:
              </Typography>
              <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
                <Chip
                  label={publishStatus}
                  color={publishStatus === 'published' ? 'success' : 'primary'}
                  size="small"
                />
              </Box>
              <RadioGroup value={publishTiming} onChange={(e) => setPublishTiming(e.target.value)}>
                <FormControlLabel value="now" control={<Radio />} label="Publish Now" />
                <FormControlLabel value="schedule" control={<Radio />} label="Schedule" />
                <FormControlLabel value="auto" control={<Radio />} label="Auto Publish" />
              </RadioGroup>
              <CardMedia
                component="img"
                image="https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=400&h=250&fit=crop"
                alt="City skyline"
                sx={{ borderRadius: 1, mt: 2 }}
              />
            </Paper>
          </Grid>

          {/* Center Content */}
          <Grid xs={12} md={6}>
            <Paper sx={{ p: 3, mb: 2 }}>
              <TextField
                fullWidth
                label="Blog Title"
                value={title}
                onChange={(e) => updateSlug(e.target.value)}
                sx={{ mb: 2 }}
              />
              <TextField
                fullWidth
                label="Slug"
                value={slug}
                onChange={(e) => setSlug(e.target.value)}
                sx={{ mb: 3 }}
              />

              <Box sx={{ display: 'flex', gap: 1, mb: 3, flexWrap: 'wrap' }}>
                <Button variant="outlined" startIcon={<AutoAwesomeIcon />} onClick={improveContent}>
                  Improve
                </Button>
                <Button variant="outlined" startIcon={<EditIcon />} onClick={rewriteContent}>
                  Rewrite
                </Button>
                <Button variant="outlined" startIcon={<ExpandMoreIcon />} onClick={expandContent}>
                  Expand
                </Button>
                <Button variant="outlined" onClick={seoOptimize}>SEO Optimize</Button>
                <Button variant="outlined" onClick={humanizeContent}>Humanize</Button>
              </Box>

              <TextField
                fullWidth
                multiline
                rows={12}
                value={blogContent}
                onChange={(e) => setBlogContent(e.target.value)}
                variant="outlined"
                placeholder="Start writing or generate AI content..."
              />

              <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
                <Button variant="contained" size="large" onClick={saveDraft}>
                  Save Draft
                </Button>
                <Button variant="contained" color="success" size="large" onClick={publishPost}>
                  Publish
                </Button>
                <Button variant="outlined" startIcon={<VisibilityIcon />} size="large">
                  Preview
                </Button>
              </Box>
            </Paper>

            {/* Blog History Tabs */}
            <Paper>
              <Tabs value={tabValue} onChange={(e, v) => setTabValue(v)}>
                <Tab label="Blog History" />
                <Tab label="Drafts" />
                <Tab label="Analytics" />
              </Tabs>
              <Box sx={{ p: 2 }}>
                {tabValue === 0 && (
                  <List>
                    {blogHistory.map((post) => (
                      <ListItem key={post.id}>
                        <ListItemIcon>
                          <CheckCircleIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText
                          primary={post.title}
                          secondary={`${post.platform} • ${post.date} • ${post.views} views`}
                        />
                      </ListItem>
                    ))}
                  </List>
                )}
                {tabValue === 1 && (
                  <List>
                    {drafts.map((draft) => (
                      <ListItem
                        key={draft.id}
                        secondaryAction={
                          <IconButton edge="end" onClick={() => deleteDraft(draft.id)}>
                            <DeleteIcon />
                          </IconButton>
                        }
                      >
                        <ListItemText
                          primary={draft.title}
                          secondary={draft.date}
                          onClick={() => loadDraft(draft)}
                          sx={{ cursor: 'pointer' }}
                        />
                      </ListItem>
                    ))}
                  </List>
                )}
                {tabValue === 2 && (
                  <Box>
                    <Typography variant="h6" gutterBottom>
                      Content Performance
                    </Typography>
                    <LineChart
                      xAxis={[{ data: [1, 2, 3, 4, 5, 6, 7, 8], label: 'Weeks' }]}
                      series={[
                        {
                          data: analytics.views,
                          area: true,
                          color: '#1976d2',
                          label: 'Views',
                        },
                      ]}
                      height={300}
                    />
                  </Box>
                )}
              </Box>
            </Paper>
          </Grid>

          {/* Right Sidebar - Preview */}
          <Grid xs={12} md={3}>
            <Paper sx={{ p: 2 }}>
              <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
                <Button
                  variant={previewMode === 'desktop' ? 'contained' : 'outlined'}
                  startIcon={<ComputerIcon />}
                  onClick={() => setPreviewMode('desktop')}
                  size="small"
                  fullWidth
                >
                  Desktop
                </Button>
                <Button
                  variant={previewMode === 'mobile' ? 'contained' : 'outlined'}
                  startIcon={<SmartphoneIcon />}
                  onClick={() => setPreviewMode('mobile')}
                  size="small"
                  fullWidth
                >
                  Mobile
                </Button>
              </Box>

              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom fontWeight={600}>
                    {title || 'Untitled Post'}
                  </Typography>
                  <CardMedia
                    component="img"
                    image="https://images.unsplash.com/photo-1677442136019-21780ecad995?w=400&h=250&fit=crop"
                    alt="AI Robot"
                    sx={{ borderRadius: 1, mb: 2 }}
                  />
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                    {blogContent.substring(0, 200) || 'No content yet...'}
                    {blogContent.length > 200 && '...'}
                  </Typography>
                </CardContent>
              </Card>

              <Box sx={{ mt: 3, p: 2, bgcolor: 'white', borderRadius: 1 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-around', mb: 2 }}>
                  <Box sx={{ textAlign: 'center' }}>
                    <Typography variant="h6" color="primary">
                      {blogHistory[0]?.views || 0}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Views
                    </Typography>
                  </Box>
                  <Box sx={{ textAlign: 'center' }}>
                    <Typography variant="h6" color="error">
                      {blogHistory[0]?.likes || 0}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Likes
                    </Typography>
                  </Box>
                  <Box sx={{ textAlign: 'center' }}>
                    <Typography variant="h6" color="info.main">
                      {blogHistory[0]?.comments || 0}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Comments
                    </Typography>
                  </Box>
                </Box>

                <LineChart
                  xAxis={[{ data: [1, 2, 3, 4, 5, 6, 7, 8] }]}
                  series={[
                    {
                      data: analytics.views,
                      area: true,
                      color: '#1976d2',
                    },
                  ]}
                  height={200}
                  margin={{ top: 10, right: 10, bottom: 30, left: 40 }}
                />
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Box>

      {/* Meta Description Dialog */}
      <Dialog open={openDialog === 'meta'} onClose={() => setOpenDialog('')}>
        <DialogTitle>Meta Description</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            multiline
            rows={4}
            value={metaDescription}
            onChange={(e) => setMetaDescription(e.target.value)}
            placeholder="Enter meta description for SEO..."
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog('')}>Cancel</Button>
          <Button onClick={() => { setOpenDialog(''); showSnackbar('Meta description saved!'); }} variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Keywords Dialog */}
      <Dialog open={openDialog === 'keywords'} onClose={() => setOpenDialog('')}>
        <DialogTitle>Keyword Suggestions</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 2 }}>
            {keywords.map((keyword, index) => (
              <Chip key={index} label={keyword} color="primary" />
            ))}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog('')} variant="contained">Close</Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default AIBlogWriter;
